import React, { ReactNode, SelectHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { FormItemName } from './FormItemName';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: ReactNode;
  options?: {
    value: string | number;
    label: ReactNode;
  }[];
  isRequired?: boolean;
  className?: string;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, className, isRequired, options = [], ...props }, ref) => (
    <>
      {!!label && <FormItemName name={label} isRequired={isRequired} className="mb-[6px]" />}
      <select
        ref={ref}
        className={twMerge(
          'w-full rounded-lg border border-gray-300 bg-gray-50 p-4',
          'font-manrope text-sm text-gray-900',
          'md:!bg-white md:!p-3 md:!text-base',
          'focus:border-[#25008a]/10 focus:border-opacity-10 focus:outline-none focus:ring-4 focus:ring-[#25008a]/10',
          className,
        )}
        {...props}
      >
        <option key="select-state" value="" disabled={isRequired}>
          Select
        </option>
        {options.map(({ value, label: optionLabel }) => (
          <option key={value} value={value}>
            {optionLabel}
          </option>
        ))}
      </select>
    </>
  ),
);

Select.displayName = 'Select';
